// extracted by mini-css-extract-plugin
export default {"root":"AddAttributeModal_root__u9DdG","form":"AddAttributeModal_form__sODRk","formInput":"AddAttributeModal_formInput__1Oaiv","footer":"AddAttributeModal_footer__uR+HP"};